/**
 * Gets the current value for a provided React.RefObject.
 * Throws an error if the ref has not been set.
 */
export function getCurrentRef(ref) {
    if (ref.current === null) {
        throw new Error('Cannot get current ref value for null ref.');
    }
    return ref.current;
}
//# sourceMappingURL=get-current-ref.js.map